export default "__VITE_ASSET__CNgNytpK__"